import clsx from 'clsx';

// Tailwind class birleştirici — shadcn/ui pattern'i
export function cn(...inputs) {
  return clsx(inputs);
}
